// Google Ads conversion tracking config.
// 1. In Google Ads → Goals → Conversions, create a "Submit lead form" action ("Quote Form Submit").
// 2. Open it → "Use Google tag" → copy the send_to value from the snippet, e.g.:
//    gtag('event','conversion',{'send_to':'AW-18341451170/AbC-D_efGhIjKl'})
// 3. Paste that value (or several) into the array below. Leave empty until you have it.
export const GADS_CONVERSION_SEND_TO = [
  "AW-18341451170",
  // If leads don't show in Google Ads, append the conversion LABEL, e.g. "AW-18341451170/AbC-D_efGhIjKl".
];

// Fires a lead conversion when a quote form is submitted. Safe no-op until configured.
export function fireLeadConversion() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    // Generic event — useful for GA4 and reporting even before a label is set.
    window.gtag("event", "generate_lead", { event_category: "quote", event_label: "quote_form" });
  } catch (e) {
    /* gtag not ready — ignore */
  }
  GADS_CONVERSION_SEND_TO.filter(Boolean).forEach((send_to) => {
    try {
      window.gtag("event", "conversion", { send_to });
    } catch (e) {
      /* gtag not ready — ignore */
    }
  });
}

// Google Ads "Phone call clicks" conversion send_to value(s).
// In Google Ads → Goals → Conversions, create a "Phone call clicks" action,
// then paste its send_to (with LABEL) here, e.g. "AW-18341451170/XyZ-123abc".
export const GADS_CALL_SEND_TO = [
  // "AW-18341451170/XxXxXxXxXxXxXxXx",
];

// Fires a call/text conversion when a tel: link is tapped. Safe no-op until configured.
export function fireCallConversion() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "click_to_call", { event_category: "call", event_label: "tap_to_call" });
  } catch (e) {
    /* gtag not ready — ignore */
  }
  GADS_CALL_SEND_TO.filter(Boolean).forEach((send_to) => {
    try {
      window.gtag("event", "conversion", { send_to });
    } catch (e) {
      /* gtag not ready — ignore */
    }
  });
}

// Attaches a single delegated listener so every tel: link across the site
// (header, hero, footer, CTAs, service/city pages) fires a call conversion.
let _callTrackingInit = false;
export function initCallTracking() {
  if (typeof document === "undefined" || _callTrackingInit) return;
  _callTrackingInit = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target && e.target.closest && e.target.closest('a[href^="tel:"]');
      if (a) fireCallConversion();
    },
    true
  );
}
